<template>
<div id="ccDetalheTorneio">

<div class="modal fade" id="modal_detalhe_torneio" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="modal-header" style="border:0;">
        <span class="text_30 text_bold text_branco">Torneio: </span> <span class="text_30 text_bold text_verde">{{torneio.nome}}</span>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <!-- <img src="../../assets/image/delete.png" width="25px" height="25px"> -->
        </button>
      </div>

      <div class="modal-body">

          <!-- TOP2 ----------------------------------- -->
          <div class="row">
            <div class="col-md-12">

              <div class="row">

                <div class="col-2">
                  <div class="text_12 text_bold text_verde">AO VIVO EM:</div>
                  <div class="text_20 text_bold text_laranja">00:00:00</div>
                </div>

                <div class="col-10">
                  <div class="card card_fundo">
                    <div class="card-body" style="padding: 18px;">
                      <div class="row">
                        <div class="col-12">
                          <span class="text_12 text_bold text_cinza">Custo entrada: </span> <span class="text_12 text_bold text_verde">R${{torneio.taxa_entrada}}</span> &nbsp;
                          <span class="text_12 text_bold text_cinza">Re-entrada: </span> <span class="text_12 text_bold text_verde">R${{torneio.max_reentrada}}</span> &nbsp;
                          <span class="text_12 text_bold text_cinza">Participantes/Max Participantes:</span> <span class="text_12 text_bold text_verde">{{torneio.qtd_aposta}}/{{torneio.max_pessoa}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- TOP2  FIM----------------------------------- -->

          <!-- LINHA DAS COLUNAS --------------- -->
          <div class="row">
                <div class="col-md-8">

                    <!-- descricao ---------- -->
                    <div class="row mb-4">
                      <div class="col-md-12">
                        <div class="text_12 text_branco mb-2">DESCRIÇÃO </div>
                        <div class="card card_fundo p-2">
                          <div class="card-body">
                            <div class="row text_cinza">
                                {{torneio.sumario}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- descricao fim---------- -->

                    <!-- jogos---------------- -->
                    <div class="row pb-4">
                      <div class="col-md-12">
                        <div class="text_12 text_branco mb-2">JOGOS DISPONÍVEIS: {{torneio.qtd_jogo}} JOGOS </div>
                        <div class="card card_fundo">
                          <div class="card-body">
                            <div class="row">

                                <div v-for="l of liga" class="mb-3 text_cinza">
                                    <div class="text_11 text_branco p-1 bg_preto text_bold">
                                      <img :src='l.logo' class="imagem" alt="Responsive image" :title='"sokkerduel"' width="22px">
                                      {{l.nome}}
                                    </div>
                                    <div v-for="jogo of jogos" v-if="l.id == jogo.liga_id"
                                    v-bind:class="[
                                      {'text_laranja':jogo.status==null},
                                      {'text_verde':jogo.status=='HT'},
                                      {'text_verde':jogo.status=='LIVE'}
                                    ]">
                                        <div class="row text_11 p-1">
                                          <div class="col-3" v-bind:class="[{text_vermelho:jogo.status=='LIVE'}]">{{jogo.aux}}</div>
                                          <div class="col-6 text">
                                            {{jogo.time1_nome.substring(0, 10)}}... &nbsp; {{jogo.localteam_score}} : {{jogo.visitorteam_score}} &nbsp; {{jogo.time2_nome.substring(0, 10)}}...
                                          </div>
                                          <div class="col-3 text-end">{{jogo.status}}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- jogos fim -->

                    <!-- participantes-->
                    <div class="row">
                      <div class="col-12">

                        <div class="row">
                          <div class="col-6">
                            <div class="text_12 text_branco">PARTICIPANTES</div>
                          </div>
                          <div class="col-6">
                            <input type="text" v-model="filter_usuario_nome" class="form-control form-control-sm"
                            placeholder="Pesquisar" v-on:keyup="filter_nome_usuario()">
                          </div>
                        </div>

                        <div class="card card_fundo" style="height:170px; overflow: auto; ">
                          <div class="card-body">
                            <div class="row">
                                <div class="col-md-3 text_branco" v-for="a of apostas" style="font-size:9px; padding:5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                                   {{a.usuario_nome}} ({{a.entrada}})
                                </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <!--participantes fim -->

                </div>
                <!-- COLUNA 8 FIM ------------------------------- -->

                <div class="col-md-4">
                    <div class="row mt-3 mb-5 pb-4">
                      <div class="col-12">
                        <div class="col-12 text_14 text_branco text_bold mt-2 mb-1">PREMIAÇÃO</div>
                        <div v-for="item in prize" class="row p-2 text_cinza">
                          <div class="col-9 estrutura_ganhos_tabela text_12 p-1" style="border-bottom: solid 1px;"> {{(item.p1 == item.p2)?item.p1+"º":item.p1+"º - "+item.p2+"º"}} </div>
                          <div class="col-3 estrutura_ganhos_tabela text_12 text_verde text_bold text-end" style="border-bottom: solid 1px;"> R${{item.ganho}} </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="btn btn-success w-100 text_13" style="text-decoration: none;" @click="perguntar_modal_mensagem(torneio_id)">
                      ENTRAR
                    </div> -->
                </div>
          </div>

          <!-- <div class="row">
            <div class="col-md-5 offset-7">
              <div class="btn btn-success w-100 text_13" style="text-decoration: none;" @click="perguntar_modal_mensagem(torneio_id)">
                ENTRAR
              </div>
            </div>
          </div> -->

      </div>

    </div>
  </div>
</div>

<ccMensagem ref="cc_mensagem" @evento_teste="resposta_modal_mensagem"></ccMensagem>
<ccAlert ref="cc_alert"></ccAlert>

</div>
</template>

<script>
  import axios from 'axios';
  import ccMensagem from '../cc_geral/mensagem.vue'
  import ccAlert from '../cc_geral/cc_alert.vue'
  import ccLoading from '../cc_geral/cc_loading.vue'

  export default {

    name: 'ccDetalheTorneio',

    data () {
        return {
          //geral
          base_url_api: process.env.BASE_URL_API,
          user: {},
          loading: true,
          errors: [],

          //variaveis
          user_logado: false,
          page_back: 0,
          tela_detalhes: true,
          tela_jogos_disponiveis: false,
          ultimo_que_ganha: 0,
          casa: 0,
          total_dinheiro: 0,
          banca: 0,
          filter_usuario_nome: "",

          //array
          torneio: [],
          torneio_id: 0,
          prize: [],
          jogos: [],
          liga: [],

          apostas:[],
          qtd_aposta: 0,
          porc_casa: 0,

          tela_detalhes: true,
          tela_jogos_disponiveis: false,
        }
    },

    components: {ccMensagem, ccAlert, ccLoading},

    methods: {

      receber_dados(torneio_id){

        this.torneio_id = torneio_id

        this.loading = true;

        let a = JSON.parse(localStorage.getItem("user"));

        if (a == null){ this.user = {} } else { this.user = a }
        this.get_user()
        this.get_torneio()
        this.get_aposta()

        var myModal = new bootstrap.Modal(document.getElementById('modal_detalhe_torneio'))
        myModal.show()
      },

      get_user(){
        this.loading = true
        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.get(this.base_url_api+'user', header)
        .then(response => {
          let a = response.data.data
          this.user.balance = a.balance
          localStorage.setItem("user", JSON.stringify(this.user));
          this.loading = false
        })
        .catch(e => {
          this.expluse_para_login()
        });
      },

      get_torneio(){
        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.get(this.base_url_api+'torneio/find_id/'+this.torneio_id, header)
        .then(response => {
          this.torneio = response.data.resp.torneio
          this.torneio.dt_inicio = this.timestamp_dataBR(this.torneio.dt_inicio_timestamp)
          this.torneio.dt_termino = this.previsao_termino(this.torneio.dt_termino_timestamp)
          this.prize = response.data.resp.prize
          this.qtd_aposta = response.data.resp.torneio.qtd_aposta
          this.porc_casa = response.data.resp.torneio.porc_casa
          this.jogos = response.data.resp.jogo
          this.dt_inicio_timestamp = response.data.resp.dt_inicio_timestamp
          this.dt_termino_timestamp = response.data.resp.dt_termino_timestamp
          this.ultimo_que_ganha = this.prize[ response.data.resp.prize.length-1 ].p2;

          this.higienizar_jogo()
          this.loading = false
        })
        .catch(e => {
          this.errors.push(e);
        });
      },

      higienizar_jogo(){
        let obj = {}

        //higienizar jogos
        let j = this.jogos
        let jogo_aux = []
        for (var i=0; i <= j.length -1; i++){
          obj = {}
          obj.fixture_id = j[i].fixture_id
          obj.liga_id = j[i].liga_id
          obj.liga_nome = j[i].liga_nome
          obj.liga_logo = j[i].liga_logo
          obj.torneio_id = j[i].torneio_id
          obj.time1 = j[i].time1
          obj.time1_nome = j[i].time1_nome
          obj.time2 = j[i].time2
          obj.time2_nome = j[i].time2_nome
          obj.dt_inicio_timestamp = j[i].dt_inicio_timestamp
          obj.dt_termino_timestamp = j[i].dt_termino_timestamp
          obj.minute = j[i].minute
          obj.localteam_score = j[i].localteam_score == null ? j[i].localteam_score = 0 : j[i].localteam_score
          obj.visitorteam_score = j[i].visitorteam_score == null ? j[i].visitorteam_score = 0 : j[i].visitorteam_score
          obj.ht_score = j[i].ht_score
          obj.ft_score = j[i].ft_score
          obj.corner_ft = j[i].corner_ft
          obj.corner_ht = j[i].corner_ht
          obj.status = (j[i].status=='' || j[i].status==null) ? 'Aguardando' : j[i].status
          obj.status_descricao = j[i].status_descricao
          obj.localteam_logo = j[i].localteam_logo
          obj.visitorteam_logo = j[i].visitorteam_logo
          obj.ht = j[i].ht
          obj.aux = this.timestamp_dataBR(obj.dt_inicio_timestamp,3)

          if(obj.status=='LIVE' || obj.status=='HT'){
            obj.aux = ((obj.minute==''||obj.minute==null) ? 0 : obj.minute) + "'"
          }

          jogo_aux.push(obj)
        }
        this.jogos = jogo_aux

        //categorize por liga
        this.liga = []
        let found = -1
        let aux = []
        j = jogo_aux
        for (var i=0; i <= j.length -1; i++){
           obj = {}
           if( aux.indexOf( j[i].liga_id ) == -1 ){
              aux.push(j[i].liga_id)

              obj.id = j[i].liga_id
              obj.nome = j[i].liga_nome
              obj.logo = j[i].liga_logo
              this.liga.push(obj)
           }
        }

      },

      get_aposta(){
        var header = {'headers': {'x-access-token': this.user.access_token, }};
        axios.get(this.base_url_api+'torneio/'+this.torneio_id+'/aposta', header)
        .then(response => {

          this.loading = false;
          let a = response.data.resp;
          var obj = {};
          var aposta = [];
          var p = this.prize;
          var porc = 0;
          var ranger = 0;

          let colocacao = "";
          for (var i=0; i <= a.length -1; i++) {
            porc = 0;
            for (var c=0; c <= p.length -1; c++) {
              if(a[i].rank >= p[c].p1 && a[i].rank <= p[c].p2 ){
                porc = p[c].porcentagem;
                ranger = p[c].ranger;
              }
            }

            obj = {
              aposta_id: a[i].aposta_id,
              aposta_id_sec: a[i].aposta_id_sec.substr(0,8),
              rank: a[i].rank,
              repetido: a[i].repetido,
              usuario_id: a[i].usuario_id,
              usuario_nome: a[i].usuario_nome,
              ponto: a[i].ponto,
              entrada: a[i].entrada,
              prize:  (((this.banca * porc) / 100)/ranger)/a[i].repetido,
              cadeado: 0,
              escolha: 0,
            };
            aposta.push(obj);
          }

          this.apostas = aposta;

        })
        .catch(e => {
        });
      },

      //************** entrar na aposta ***************** */
      perguntar_modal_mensagem(id){
          this.torneio_id = id;

          var body = {
            usuario_id: this.user.id,
            torneio_id: this.torneio_id,
          };

          var header = {'headers': {'x-access-token': this.user.access_token, }};
          axios.post(this.base_url_api+'aposta/autorizacao', body, header)
          .then(response => {

            if(response.data.resp.erro == null){
              this.$refs.cc_mensagem.receber_dados("Uma vez que entrar, só poderá editar e não cancelar!");
            }else{
              let m = response.data.resp.erro;
              this.$refs.cc_alert.receber_dados(m);
            }

          })
          .catch(e => {
            // this.errors.push(e);
            this.expluse_para_login()
          });
      },

      resposta_modal_mensagem(variable){
          if(variable){

            alert('aqui')
            
            // this.montar_aposta_temporaria()
          }
      },

      montar_aposta_temporaria(){
          this.loading = true
          var body = {torneio_id: this.torneio.id, }
          var header = {'headers': {'x-access-token': this.user.access_token, }};
          axios.post(this.base_url_api+'aposta/save/temp', body, header)
          .then(response => {

            if(response.data.resp.erro == null){
              this.$router.push({ path: process.env.BASE_LOCAL+"#/palpite/"+response.data.resp.aposta_id+"/editar", replace: true })
            }
            // else{
            //   let te = response.data.resp.erro;
            //   this.$refs.cc_alert.receber_dados(te);
            // }

            this.loading = false
          })
          .catch(e => {
            this.errors.push(e);
            this.expluse_para_login()
          });

      },
      //************** entrar na aposta fim ***************** */


    },
  }

</script>


<style scoped>

  .modal-content{
    background: #232633;
  }

  .card_fundo{
     background-color: #1a1c25;
     border-radius: 10px;
  }

  input.form-control {
    background-color: #21232d;
    border: none;
    color: #909196;
    margin-bottom: 10px;
  }

  input.form-control.disabled {
    background-color: #21232d;
    opacity: 0.5;
  }

  select.form-control {
    background-color: #21232d;
    border: none;
    color: #909196;
    margin-bottom: 10px;
  }

  input.form-control::placeholder {
    color: #8f5f34;
  }

</style>


// WEBPACK FOOTER //
// src/components/cc_geral/cc_detalhe_torneio_modal.vue